import React, { useContext, useEffect, useState } from "react";

import { useNavigate, Link } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff } from "lucide-react";
// import Input from "@material-ui/core/Input";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

import { loginWithEmail } from "../../services/firebase";
import AuthContext from "../../hooks/authContext";
import validator from "validator";
import { findClientsByEmail, saveLogins, syncClientContactLogin } from "../../services/apiservices/client";
// import { Button } from "../";
// import { Input } from "@/components/ui/input";
// import { useToast } from "@/hooks/use-toast";
// import { useAuth } from "@/contexts/AuthContext";

const LoginForm = (props) => {
  const navigate = useNavigate();
  // const { toast } = useToast();
  const [showPassword, setShowPassword] = useState(false);
  // const { login } = useAuth();
  const auth = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [state, setState] = useState({
    formState: { username: "", password: "" },
    loading: false,
    sRedirect: "",
    remember: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name !== "") {
      setState({ ...state, formState: { ...state.formState, [name]: value } });
    }
  };
  const setInitState = () => {
    setState({
      ...state,
      remember: localStorage.remember,
      sRedirect: "",
      formState: {
        ...state.formState,
        username: localStorage.username,
        // password: localStorage.password,
      },
    });
  };
  useEffect(() => {
    if (localStorage.remember && localStorage.username !== "") {
      setInitState();
    }
  }, []);
  const redirecifloggedin = () => {
    navigate("/dashboard");
  };
  useEffect(() => {
    if (auth.status === true) {
      redirecifloggedin();
    }
  }, [auth.status]);

  const onChangeCheckbox = (event) => {
    setState({ ...state, remember: event.target.checked });
  };

  const userlogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");
    setState({ ...state, loading: true });
    const { remember } = state;
    let { username, password } = state.formState;

    username = username?.trim();
    password = password?.trim();
    
    if (username !== "" && password !== "") {
      if (remember) {
        localStorage.username = username;
        localStorage.password = password;
        localStorage.remember = remember;
      } else {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
        localStorage.removeItem("remember");
      }
      if (!validator.isEmail(username)) {
        setErrorMessage("Email Address is not Valid");
        setState({
          ...state,
          sRedirect: "",
          loading: false,
        });
      } else {
        let loginRes = await loginWithEmail(username, password);
        if (loginRes?.token && loginRes?.token !== "") {
          setState({ ...state, loading: false });
          setTimeout(() => {
            auth.login(loginRes?.token);
            if(loginRes?.role === "superUser"){
              navigate("/superuserDashboard");
            } else {
              navigate("/dashboard");
            }
          });
          saveLogins(loginRes?.userId);
          syncClientContactLogin(loginRes?.userId, loginRes?.user?.email);
          const data = await findClientsByEmail(loginRes?.user?.email);
          if(data?.clients?.length > 0 && data?.companies?.length > 0){
            localStorage.setItem("companies", JSON.stringify(data?.companies));
            localStorage.setItem("clients", JSON.stringify(data?.clients));
            localStorage.setItem("companyId", data?.clients?.[0]?.companyId);
            localStorage.setItem("clientId", data?.clients?.[0]?.id);
          }
        } else {
          setErrorMessage("Email or password does not match");
          setState({ ...state, sRedirect: "", loading: false });
        }
      }
    } else {
      setErrorMessage("Email and/or Password are required");
      setState({
        ...state,
        sRedirect: "",
        loading: false,
      });
    }
    setState({ ...state, loading: false });
  };

  const { formState, loading, remember, sRedirect } = state;
  const { classes } = props;

  // Simplified login - no validation or authentication required
  const handleLogin = () => {
    // // Just log in without checking credentials
    // login("demo@proteams.io", "demo-password");

    // toast({
    //   title: "Welcome back!",
    //   description: "You've successfully logged in.",
    // });
    navigate("/");
  };

  return (
    <div className="space-y-6">
      {/* Email field - no validation */}
      <div className="space-y-2">
        <label htmlFor="email" className="block text-sm font-medium">
          Email Address
        </label>
        <div className="relative">
          <Mail className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <Input
            fullWidth={true}
            disableUnderline={true}
            onChange={handleInputChange}
            value={formState.username}
            autoComplete="email"
            className="pl-35 dark:bg-white"
            name="username"
            id="username"
            placeholder="Email"
          />
        </div>
      </div>

      {/* Password field - no validation */}
      <div className="space-y-2">
        <div className="flex justify-between items-baseline">
          <label htmlFor="password" className="block text-sm font-medium">
            Password
          </label>
          <Link
            to="/forgotpassword"
            className="text-sm text-green-600 hover:text-green-800"
          >
            Forgot password?
          </Link>
        </div>
        <div className="relative">
          <Lock className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <Input
            fullWidth={true}
            disableUnderline={true}
            onChange={handleInputChange}
            value={formState.password}
            autoComplete="current-password"
            className="pl-35 dark:bg-white"
            name="password"
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Password"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-3 text-gray-400 hover:text-gray-600"
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>

      {/* Login button - no form validation */}

      <Button
        type="button"
        className="w-full"
        onClick={userlogin}
        size="lg"
        disabled={loading ? true : false}
      >
        {loading ? "Loading..." : "LOG IN"}
      </Button>
      {errorMessage !== "" && (
        <div className="text-center error-message mt-2">{errorMessage}</div>
      )}

      <div className="text-center text-sm text-gray-500">
        Don't have an account?{" "}
        <Link
          to="/register"
          className="text-green-600 hover:text-green-800 font-medium"
        >
          Start your free trial
        </Link>
      </div>
    </div>
  );
};

export default LoginForm;
